import type * as models from 'pkg/api/models';
import type { AllowedActionable } from 'pkg/api/models/allowed_actionable';
import type { Record } from 'pkg/api/models/record';

export enum EventSeriesUserResponseStatus {
	Pending = 'pending',
	Accepted = 'accepted',
	Declined = 'declined',
}

export enum EventSeriesUserFlags {
	LokLeader = 'lok_leader',
	LokHasHandicap = 'lok_has_handicap',
}

export enum EventSeriesUserRole {
	Organizer = 'organizer',
	Participant = 'participant',
}

export interface EventSeriesUser extends Record, AllowedActionable {
	userId: number;
	eventSeriesId: number;

	status: EventSeriesUserResponseStatus;
	flags: EventSeriesUserFlags;
	role: EventSeriesUserRole;
	user: models.user.User;
	eventSeries: models.eventSeries.EventSeries;
}
